import React, { useEffect } from 'react';
import { MarketingHeader } from './MarketingHeader';
import { MarketingFooter } from './MarketingFooter';
import { markMarketingVisitor } from '../../utils/launchContext';

export function MarketingLayout({ children }) {
  useEffect(() => {
    markMarketingVisitor();
  }, []);

  return (
    <div
      data-testid="marketing-layout"
      style={{
        minHeight: '100vh',
        background: 'var(--mkt-page-bg)',
        color: 'var(--mkt-text)',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: "'Manrope', sans-serif",
        transition: 'background-color 240ms ease, color 240ms ease',
      }}
    >
      <MarketingHeader />
      <main style={{ flex: 1 }}>{children}</main>
      <MarketingFooter />
    </div>
  );
}
